import { UserHeader } from "./components/UserHeader/UserHeader";
import { UserTable } from "./components/UserTable/UserTable";

export const UserManagement = () => {
  return (
    <>
      <UserHeader />
      <UserTable />
    </>
  );
};
